import { createFileRoute } from "@tanstack/react-router";
import { ApprovalsPage } from "@/features/portalapprovals/ApprovalsPage";

// The contact approvals (X13-0310b) render inside ApprovalsPage, in its one portal frame.
export const Route = createFileRoute("/portal/approvals/")({ component: ApprovalsPage });
